import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { IOrgStageCoordsGetterOutput } from '../functions/getOrgStages-1'
import { D3Rect } from '../../D3Components/D3Rect'
import { colors, constants } from '../../../Constants'
import RootStoreContext from '../../../storage/RootStore'
import D3Line from '../../D3Components/D3Line'
import { getOrgInfo, getOrgsForStage } from '../../../dict/ORGS'
import {isSafari, isMobileSafari} from 'react-device-detect'
import { toJS } from 'mobx'

/// functions
/// types
/// components

interface RowLabelsProps extends IOrgStageCoordsGetterOutput { }


export const RowLabels: React.FC<RowLabelsProps> = observer(({
    orgStagesCoords, arrayOrgNodes, connectionDotsCoords, arrayStages
}) => {
    const { selection, debugging } = useContext(RootStoreContext)
    const { BLOCK, HIGHLIGHT_LINE } = constants

    return (<g className='row-labels'>
        {arrayOrgNodes && arrayOrgNodes.map((row, i) => {
            const orgID = '' + row[0]
            const { orgName, orgFullname } = getOrgInfo(orgID)
            const selected = selection.org === orgID
            const connected = getOrgsForStage(selection.stage).includes(orgID)

            const fillColor = (
                selected ? constants.BLOCK.COLOR_SELECTED_LABEL :
                connected && !selection.orgStage ? constants.BLOCK.COLOR_SELECTED :
                'transparent'
            )

            return (
                <>
                    <D3Rect
                        x={0} y={i * BLOCK.HEIGHT}
                        width={BLOCK.WIDTH}
                        height={BLOCK.HEIGHT}
                        cursor={'pointer'}
                        labelAlign={isSafari || isMobileSafari ? 'center' : 'right'}
                        rectColor={fillColor}
                        styles={{ justifyContent: 'left' }}
                        onClick={() => selection.setOrg(orgID.toString())}
                        children={<text style={{ color: (selected) ? 'white' : 'black', fontWeight: 500 }}>{orgName}</text>}
                    />
                    <D3Line
                        from={[20, i * BLOCK.HEIGHT]}
                        to={[BLOCK.WIDTH, i * BLOCK.HEIGHT]}
                        strokeColor={'rgba(25,25,25,0.2)'}
                        strokeWidth={0.5}
                    />
                </>
            )
        })}
    </g>)
})
